export default "__VITE_ASSET__BfYmXeVT__"